/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2022-09-27 21:05:23
 * @modify date 2022-09-27 21:05:23
 * @desc 用户属性UB
 */
/**
 * BU
 * @export
 * @enum {number}
 */
export enum EnumBusiness {
  REL = 'BU001',
  CON = 'BU004',
  SMB = 'BU005',
  ISG = 'BU006',
  SERVICEB = 'BU007',
  /** @name 内部平台用户 */
  PLATFORM = 'BU999',
}
/**
 * 用户类型
 * @export
 * @enum {number}
 */
export enum EnumUserType {
  /** @name 意向伙伴 */
  Intention = '1',
  /** @name 合作伙伴 */
  Cooperation = '2',
  /** @name Sales */
  Sales = '3',
}
/**
 * 合作类型
 * @export
 * @enum {number}
 */
export enum EnumCooperateType {
  /** @name 注册伙伴 */
  Registered = '1',
  /** @name 合作伙伴 */
  Signing = '2',
  /** @name 合作伙伴 */
  Store = '6',
}

/**
 * 渠道等级
 * @export
 * @enum {number}
 */
export enum EnumPartnerTier {
  /** @name T1 */
  T1 = '1',
  /** @name T2 */
  T2 = '2',
  /** @name 服务站账号 */
  ServiceStation = '4',
}
